module.exports = __webpack_public_path__ + "ec4320ec7b015ee63a3e2d74b7769326.fbx";